import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import {
  QrcodeOutlined,
  EyeOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

import { Container, Table, Card } from "./styles";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import {
  Pagination,
  Spin,
  Button,
  Modal,
  Image,
  Popover,
  Typography,
} from "antd";
import Status from "../../../components/status";
import { Message } from "../../../GlobalStyles";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { MdAdd, MdVisibility } from "react-icons/md";

const { Title, Paragraph, Text } = Typography;

const Pagamentos = () => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [paymentsTotal, setPaymentsTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [balance, setBalance] = useState(0);
  const [bonus, setBonus] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const showModal = (payment) => {
    setSelectedPayment(payment);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    loadPayments(page);
  }, [page]);

  async function loadPayments(page) {
    setIsLoading(true);
    await api
      .get(`/payments?page=${page}`)
      .then((response) => {
        setPayments(response.data.payments);
        setTotalValue(response.data.totalValue);
        setPaymentsTotal(response.data.paymentsTotal);
        setBalance(response.data.balance);
        setBonus(response.data.bonus);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  const infoContent = (
    <div>
      <Paragraph>
        O saldo em sua conta pode ser utilizado para adquirir qualquer produto
        ou serviço em nossa plataforma. o bonus apenas para compra de Leads
      </Paragraph>
      <Paragraph>
        Efetue deposito via PIX e seu saldo ficará disponivel após confirmação
        do pagamento
      </Paragraph>
    </div>
  );

  return (
    <Container>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1>Minha Carteira</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => navigate("/clientes/adicionar-saldo")}
        >
          <MdAdd size={20} color="#FFF" />
          Adicionar Saldo
        </Button>
      </div>

      {isLoading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card style={{ marginBottom: 20 }}>
            <p>Total</p>
            <CountUp duration={1} end={paymentsTotal} separator="." />
          </Card>
          <p>
            Saldo disponível:
            <Popover
              content={infoContent}
              title="Como funciona"
              trigger="click"
            >
              <InfoCircleOutlined
                style={{
                  cursor: "pointer",
                  marginLeft: 10,
                  color: "#001b22",
                  fontSize: 16,
                }}
              />
            </Popover>
          </p>
          <h3>
            <CountUp
              duration={1.5}
              end={balance}
              prefix="R$ "
              separator="."
              decimal=","
              decimals={2}
            />
            {!!bonus && (
              <span style={{ fontSize: 18 }}>
                <CountUp
                  duration={1.5}
                  end={bonus}
                  prefix="  + R$ "
                  separator="."
                  decimal=","
                  decimals={2}
                />
              </span>
            )}
            <span style={{ fontSize: 13 }}>
              {!!bonus && `  para comprar de leads`}
            </span>
          </h3>

          {!!totalValue && (
            <h4 style={{ marginTop: 30, marginBottom: -10 }}>
              {" "}
              {totalValue.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}{" "}
              total em pagamentos
            </h4>
          )}
          <div className="orders">
            {paymentsTotal ? (
              <Table>
                <thead>
                  <tr>
                    <td>Tipo</td>
                    <td>Valor</td>
                    <td>Método</td>
                    <td>Status</td>
                    <td>Ultima atualização</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((payment) => {
                    return (
                      <tr key={payment.id}>
                        <td
                          onClick={() => {
                            if (payment.type == "OS") {
                              navigate(`/clientes/os/${payment.order_id}`);
                            }
                          }}
                          style={{
                            fontWeight: "800",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          <Button type="primary" style={{ height: 25 }}>
                            {payment.type == "OS"
                              ? `OS: ${payment.order_id}`
                              : payment.type == "LEAD"
                              ? `LEAD`
                              : "DEPOSITO"}
                          </Button>
                        </td>
                        <td style={{ textTransform: "capitalize" }}>
                          {(payment.value || 0).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </td>
                        <td>{payment.method}</td>
                        <td
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Status
                            status={payment.status}
                            isPayment={true}
                            style={{
                              fontSize: 11,
                              height: 20,
                              paddingBottom: 2,
                            }}
                          />
                        </td>
                        <td>
                          {format(
                            new Date(payment.update_at),
                            "dd/MM/yyyy HH:mm"
                          )}
                        </td>
                        <td>
                          <MdVisibility
                            size={22}
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              navigate(`/clientes/pagamento/${payment.id}`)
                            }
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : (
              <Message>Nenhum pagamento encontrado</Message>
            )}
          </div>
          <center>
            <Pagination
              style={{ marginTop: 15, justifySelf: "center" }}
              defaultCurrent={page + 1}
              onChange={(page) => {
                setPage(page - 1);
              }}
              total={paymentsTotal}
              pageSize={30}
            />
          </center>
        </>
      )}
      {selectedPayment && (
        <Modal
          title="Detalhes da Transação"
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          {selectedPayment.method === "pix" &&
            selectedPayment.status === "pending" && (
              <>
                <p>Scaneie o QR Code para pagar:</p>
                <Image width={200} src={selectedPayment.qr_code} />
              </>
            )}
        </Modal>
      )}
    </Container>
  );
};

export default Pagamentos;
